import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

const Sidebar = ({ setPageTitle }) => {
  const { t } = useTranslation();

  const user = JSON.parse(localStorage.getItem("user"))
  const navigate = useNavigate();
  const location = useLocation();
console.log(localStorage.getItem("user"))
  const navigationItems = [
    {
      label: t("dashboard"),
      path: "/admin-dashboard",
      icon: "/images/img_mingcute_home_4_fill.svg",
      badge: null,
      tooltip: t("overviewTooltip"),
    },
    {
      label: t("orders"),
      path: "/order-management",
      icon: "/images/img_cart.svg",
      badge: 3,
      tooltip: t("orderProcessingTooltip"),
    },
    {
      label: t("customers"),
      path: "/customer-management",
      icon: "/images/img_users.svg",
      badge: null,
      tooltip: t("manageCustomersTooltip"),
    },
    {
      label: t("coupon_management"),
      path: "/coupon-management",
      icon: "/images/img_ticket.svg",
      badge: null,
      tooltip: null,
    },
    {
      label: t("categories"),
      path: "/category-management",
      icon: "/images/img_circle_square.svg",
      badge: null,
      tooltip: t("organizeCategoriesTooltip"),
    },

    {
      label: t("add_product"),
      path: "/add-product",
      icon: "/images/img_circle_plus.svg",
      badge: null,
      tooltip: null,
    },

    {
      label: t("product_list"),
      path: "/product-catalog-management",
      icon: "/images/img_fluent_mdl2_product_list.svg",
      badge: null,
      tooltip: null,
    },

    {
      label: t("advertisement_management"),
      path: "/advertisement-management",
      icon: "/images/img_search.svg",
      badge: null,
      tooltip: null,
    },
    /*  {
      label: t("privacy-policy-management"),
      icon: "/images/img_search.svg",
      badge: null,
      path: "/images/img_material_symbol_gray_600_22x22.svg",
      tooltip: null,
    },*/
  ];

  const handleNavigation = (path, label) => {
    navigate(path);
    setPageTitle(label);
  };

  const isActiveRoute = (path) => {
    return location.pathname === path;
  };

  return (
    <aside className="w-full sm:w-[100%] h-auto bg-white shadow-[0px_3px_4px_#0000001e] pt-5">
      {/* Header */}
      <div className="flex justify-between items-center w-full px-5 mb-7">
        <img
          src="/images/img_sidebar_logo.svg"
          alt=""
          className="w-[120px] h-[18px]"
        />
        <img
          src="/images/img_material_symbol.svg"
          alt="Close"
          className="w-6 h-6 cursor-pointer hover:opacity-80"
        />
      </div>

      {/* Main Menu Section */}
      <div className="px-6 mb-4">
        <span className="text-[15px] font-normal text-[#6a717f]">
          {t("main_menu")}
        </span>
      </div>

      {/* Navigation Items */}
      <div className="flex flex-col items-center w-full px-2">
        {navigationItems.map(({ label, path, icon, badge }, index) => {
          const active = isActiveRoute(path);
          return (
            <div
              key={index}
              onClick={() => handleNavigation(path, label)}
              className={`flex justify-start items-center w-full p-3 mb-3 rounded-md cursor-pointer transition-colors ${
                active ? "bg-[#4ea674]" : "hover:bg-gray-50"
              }`}
              title={label}
            >
              <img
                src={icon}
                alt={label}
                className={`w-[22px] h-[22px] ml-2 ${
                  active ? "filter brightness-0 invert" : ""
                }`}
              />
              <span
                className={`text-base ml-2 ${
                  active
                    ? "font-bold text-white"
                    : "text-[#6a717f] hover:text-black"
                }`}
              >
                {label}
              </span>
           
            </div>
          );
        })}

        {/* User Profile Section */}
        <div className="flex justify-start items-center w-full bg-white rounded-lg p-2.5 mb-3 mx-2 mt-6">
          <div className="flex gap-3 justify-start items-center w-full ml-1.5">
            <img
              src="/images/img_17_picture.png"
              alt="User  Avatar"
              className="w-10 h-10 rounded-full"
            />
            <div className="flex flex-col justify-start items-start flex-1">
            
              <span className="text-sm text-[#737373]">
            {user?.account}
              </span>
            </div>
          </div>
          <img
            onClick={() => {
              localStorage.clear();
              window.location.href="/login"
            }}
            src="/images/img_ic_round_logout.svg"
            alt="Logout"
            className="w-5 h-5 mr-2 cursor-pointer hover:opacity-80"
          />
        </div>

        {/* Your Shop Button
        <div
          className="flex justify-center items-center w-auto px-2 mb-3"
          onClick={() => handleNavigation("/store-information-management")}
        >
          <div className="flex justify-center items-center w-auto bg-[#4ea674] rounded-md p-3">
            <img src="/images/img_frame.svg" alt="Shop" className="w-6 h-6" />
            <span className="text-base font-bold text-white ml-1.5">
              Your Shop
            </span>
            <img
              src="/images/img_link_external.svg"
              alt="External Link"
              className="w-4 h-4 ml-[86px]"
            />
          </div>
        </div>*/}
      </div>
    </aside>
  );
};

export default Sidebar;
